import {
  CHECK_IN_MODAL,
  OPEN_MODAL,
  START_FETCHING_TIMETABLE,
  TIMETABLE_ERROR,
  UPDATE_LATEST_PARTIAL_TIMETABLE_FAILURES,
  UPDATE_TIMETABLE,
} from '../actions/timetable'
import { TimetableAction } from '../actions/timetable'
import { TimetableState } from '../types'

export const initialState = {
  loading: false,
  error: '',
  requestOrigin: null,
  modal: {
    open: false,
    message: '',
    checked: false,
    pendingRequestOrigin: null,
  },
  usedTimetableParams: [],
  partialFailuresByShiftId: {},
}

const timetableReducer = (
  state: TimetableState = initialState,
  action: TimetableAction
): TimetableState => {
  switch (action.type) {
    case START_FETCHING_TIMETABLE:
      return {
        ...state,
        loading: true,
        error: '',
        requestOrigin: action.payload,
        modal: { ...state.modal, ...{ open: false, pendingRequestOrigin: null } },
        usedTimetableParams: [],
      }

    case UPDATE_TIMETABLE:
      return {
        ...state,
        error: '',
        loading: false,
        modal: {
          ...state.modal,
          ...{ open: false, checked: false, pendingRequestOrigin: null },
        },
        usedTimetableParams: [],
      }

    case TIMETABLE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        modal: {
          ...state.modal,
          ...{ open: false, checked: false, pendingRequestOrigin: null },
        },
        usedTimetableParams: [],
      }

    case UPDATE_LATEST_PARTIAL_TIMETABLE_FAILURES: {
      const { shiftId, isUsedForDriving, failedParts } = action.payload
      const partialFailuresForShift = state.partialFailuresByShiftId[shiftId] || {}
      const timetableKind = isUsedForDriving ? 'driving' : 'nonDriving'

      return {
        ...state,
        partialFailuresByShiftId: {
          ...state.partialFailuresByShiftId,
          [shiftId]: {
            ...partialFailuresForShift,
            [timetableKind]: failedParts,
          },
        },
      }
    }

    case OPEN_MODAL:
      return {
        ...state,
        usedTimetableParams: action.payload.usedTimetableParams,
        modal: {
          ...state.modal,
          ...{
            open: action.payload.isOpen,
            checked: false,
            pendingRequestOrigin: action.payload.pendingRequestOrigin,
          },
        },
      }

    case CHECK_IN_MODAL:
      return { ...state, modal: { ...state.modal, ...{ checked: action.payload } } }

    default:
      return state
  }
}

export default timetableReducer
